import NavTitle from './nav-title'

export default {
    install: function(Vue) {
        Vue.component('NavTitle', NavTitle)
    }
}